import { Button, Input } from '@features/ui';
import { XIcon } from 'lucide-react';
import { FC, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { UserProfile } from '@src/types/users.ts';

interface GeneralUserProps {
  user: UserProfile | null;
}
export const GeneralUser: FC<GeneralUserProps> = ({ user }) => {
  const [tagNames, setTagNames] = useState<string[]>([]);
  const [tagNameText, setTagNameText] = useState<string>('');

  const { t } = useTranslation();

  const handleAddTagName = useCallback(() => {
    setTagNames((prev) => prev.concat(tagNameText));
    setTagNameText('');
  }, [tagNameText]);

  const handleRemoveTagName = useCallback((index: number) => {
    setTagNames((prev) => prev.filter((_, i) => index !== i));
  }, []);

  return (
    <div>
      <div className={'flex gap-5'}>
        <div className={'flex-1'}>
          <p className={'text-sm mb-[15px]'}>{t('users.accountTag')}</p>
          <Input
            endIcon={
              <Button
                className={'-mr-2'}
                size={'sm'}
                variant={'lime'}
                onClick={handleAddTagName}
              >
                Add
              </Button>
            }
            placeholder={t('users.placeholder.accountTag')}
            textSize={'xs'}
            value={tagNameText}
            variant={'secondary'}
            onChange={(e) => setTagNameText(e.target.value)}
          />
        </div>
      </div>
      <div className={'flex gap-5 mt-3'}>
        <div className={'flex-1'}>
          <p className={'text-sm my-2'}>{t('users.staffActionsFreebies')}</p>
          <div className={'flex gap-3.5 mb-3.5'}>
            <Button className={'w-[83px]'} size={'sm'} variant={'yellow'}>
              {t('users.button.refund')} {user?.total_refund || '-'}
            </Button>
            <Button className={'w-[83px]'} size={'sm'} variant={'lime'}>
              {t('users.button.reset')} -
            </Button>
          </div>
          <Button className={'w-[83px]'} size={'sm'} variant={'lime'}>
            {t('users.button.account')} {user?.total_free_accounts || '-'}
          </Button>
        </div>
        <div className={'flex-1 flex flex-col gap-2 ml-[13px]'}>
          {tagNames.map((item, index) => (
            <div key={`${item}_${index}`} className={'flex gap-1 items-center'}>
              <p className={'text-xs'}>
                {index + 1}. {item}
              </p>
              <button onClick={() => handleRemoveTagName(index)}>
                <XIcon className={'size-5 cursor-pointer'} />
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
